exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n#app {\n  width: 100%;\n  position: relative;\n  height: 100%;\n  min-width: 1200px;\n  min-height: 605px;\n}\n", ""]);

// exports
